import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerService } from '../services/customer.service';

@Pipe({
  name: 'customer'
})
export class CustomerPipe implements PipeTransform {

  constructor(private _customerService: CustomerService){ }

  transform(value: number): Observable<string> {
    if(typeof(value) !== 'number') return of(null);
    return this._customerService.getCustomerById(value, true).pipe(map(x => [x.customernumber, x.customername].filter(x => x? true: false).join(' ')));
  }

}
